import type { SVGProps } from "react";
export interface ChatIndicatorIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ChatIndicatorIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ChatIndicatorIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M1.205 22.795c.276.277.677.39 1.057.3l4.758-1.142c4.166 2.085 9.37 1.39 12.847-2.086l.467-.496a11.11 11.11 0 0 0 2.673-8.989 1.125 1.125 0 0 0-2.226.325 8.86 8.86 0 0 1-2.133 7.174l-.372.394a8.88 8.88 0 0 1-10.563 1.498 1.13 1.13 0 0 0-.806-.108l-3.385.813.813-3.385a1.13 1.13 0 0 0-.108-.806A8.88 8.88 0 0 1 5.725 5.724a8.86 8.86 0 0 1 7.568-2.505 1.126 1.126 0 0 0 .325-2.226c-3.356-.491-6.9.555-9.485 3.14C.656 7.61-.038 12.814 2.047 16.98L.906 21.738c-.091.38.022.78.299 1.057"
      />
      <path
        fill={color}
        d="M16 11.628a.62.62 0 0 0-.124.373l.011.126a.6.6 0 0 0 .113.243zm1 .742a.6.6 0 0 0 .112-.243l.013-.127-.013-.126a.6.6 0 0 0-.111-.246zm-4.388-.495a.6.6 0 0 0-.111-.247v.742a.6.6 0 0 0 .11-.243l.014-.127zm-1.112-.247a.62.62 0 0 0-.124.373l.011.126a.6.6 0 0 0 .113.243zm-3.388.246A.6.6 0 0 0 8 11.628v.742a.6.6 0 0 0 .11-.243L8.126 12zM7 11.628a.62.62 0 0 0-.124.373l.011.126A.6.6 0 0 0 7 12.37zM20.875 4.5a1.376 1.376 0 1 0-2.752.001 1.376 1.376 0 0 0 2.752 0ZM9.125 12a1.626 1.626 0 0 1-3.241.166l-.009-.165.009-.167a1.625 1.625 0 0 1 1.616-1.46l.167.01a1.625 1.625 0 0 1 1.459 1.617Zm4.5 0a1.626 1.626 0 0 1-3.241.166l-.009-.165.009-.167A1.625 1.625 0 0 1 12 10.373l.167.01A1.625 1.625 0 0 1 13.626 12Zm4.5 0a1.626 1.626 0 0 1-3.241.166l-.009-.165.009-.167a1.625 1.625 0 0 1 1.616-1.46l.167.01a1.625 1.625 0 0 1 1.458 1.617Zm5-7.5a3.625 3.625 0 1 1-7.25-.002 3.625 3.625 0 0 1 7.25.002"
      />
    </svg>
  );
}
